import { Button, Stack, SvgIcon, Typography } from '@mui/material';
import ConfirmationMailIcon from '@assets/icons/confirmationMail.svg?component';
import { LeadCaptureConfirmationProps } from './LeadCaptureConfirmation.types';

const LeadCaptureConfirmation = ({ onClose, leadId, actionLabel, onAction }: LeadCaptureConfirmationProps) => {
  const hasCustomAction = !!actionLabel && !!onAction;
  const buttonLabel = hasCustomAction ? actionLabel : 'CLOSE';
  const buttonHandler = hasCustomAction ? onAction : onClose;
  const buttonVariant = hasCustomAction ? 'contained' : 'outlined';

  return (
    <Stack alignItems="center" justifyContent="center" p={{ xs: '0 20px', sm: '0 70px' }}>
      <Stack mt="67px">
        <SvgIcon component={ConfirmationMailIcon} inheritViewBox className="lead-capture-confirmation-icon" />
      </Stack>
      <Stack alignItems="center" mt="24px">
        <Typography variant="title.dialog" className="lead-capture-confirmation-title">
          All Set!
        </Typography>
        <Typography
          variant="body.md"
          className="lead-capture-confirmation-body"
          mt="10px"
          textAlign="center"
        >
          {`Your request just zoomed into our inbox. Your request number is ${leadId}. We'll be in touch soon!`}
        </Typography>
      </Stack>
      <Stack m="30px 0 24px 0" className="lead-capture-confirmation-actions">
        <Button variant={buttonVariant} onClick={buttonHandler}>
          {buttonLabel}
        </Button>
      </Stack>
    </Stack>
  );
};

export default LeadCaptureConfirmation;
